// extracted by mini-css-extract-plugin
export var container = "index-module--container--e6852";
export var footer = "index-module--footer--8aefb";
export var footerLeft = "index-module--footer-left--5bbd4";
export var footerRight = "index-module--footer-right--a2e05";